// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"3d401b3d","456":"2fcf8183","480":"6bf5b372","532":"2929a212","944":"a1be72c9"}[chunkId] + ".chunk.js";
};